<template>
  <div>
    <b-row class="content-header mb-2">
      <!-- Content Left -->
      <b-col class="content-header-left" cols="12" md="9">
        <breadcrumb />
      </b-col>

      <!-- Content Right -->
      <b-col class="content-header-right text-md-right" md="3" cols="12">
        <b-button
          @click="showFormModal(null)"
          class="px-3 text-capitalize"
          variant="primary"
        >
          <feather-icon size="16" icon="PlusIcon" class="mr-50" />
          ایجاد کشور
        </b-button>
      </b-col>
    </b-row>
    <div v-if="countries">
      <div class="d-flex justify-content-between align-items-center">
        <per-page class="col-sm-12 col-md-3 col-lg-2" v-model="perPage"  />
        <!-- <search ref="countriesSearchComponent" class="w-50" v-model="searchInput" /> -->
      </div>

      <b-card body-class="p-0" class="mt-1">
        <table-head ref="countriesTableHeadComponent" :items="tableHeadings" @sort="sort" />
        <b-row
          class="py-1 mx-1 border-bottom"
          v-for="country in countries"
          :key="country.id"
        >
          <b-col class="d-flex align-items-center pl-0">
            {{ country.name }}
          </b-col>

          <b-col
            class="d-flex align-items-center flex-row-reverse"
            style="direction: ltr"
          >
            {{ new Date(country.created_at).toLocaleString('fa-IR', { timeZone: 'Iran' })}}
          </b-col>
          <b-col class="d-flex align-items-center">
            <b-button
              @click="showConfirmModal(country)"
              variant="flat-danger"
              class="font-weight-bolder"
            >
              <feather-icon icon="Trash2Icon" size="20" />
            </b-button>
            <b-button
              @click="showFormModal(country)"
              variant="flat-secondary"
              class="font-weight-bolder"
            >
              <feather-icon icon="Edit2Icon" size="20" />
            </b-button>
          </b-col>
        </b-row>
      </b-card>
      <pagination ref="countriesPaginationComponent" v-model="page" :paginationData="paginationData" />
    </div>
    <b-sidebar
      width="500px"
      v-model="formModal"
      right
      backdrop
      shadow
      bg-variant="white"
    >
      <template #header>
        <div class="w-100">
          <div class="text-right">
            <b-button
              style="background-color: rgba(75, 75, 75, 0.12)"
              @click="formModal = false"
              variant="flat-dark"
              class="btn-icon rounded-circle mr-1"
            >
              <feather-icon icon="XIcon" size="20" />
            </b-button>
          </div>
          <div class="mr-1 sidebarHeaderTitleDiv">
            <h3 class="text-capitalize">
              {{ editMode ? "ویرایش کشور" : "ایجاد کشور" }}
            </h3>
          </div>
        </div>
      </template>
      <b-container class="">
       
        <b-form-group class="mt-3">
          <label for="country_name" class="text-capitalize"
            >{{ $t("first name") }}:</label
          >
          <b-form-input
            id="country_name"
            v-model="countryInput.name"
            type="text"
          />
        </b-form-group>
         <b-form-group class="mt-1">
          <label for="country_slug" class="text-capitalize"
            >اسلاگ| slug:</label
          >
          <b-form-input
            id="country_slug"
            v-model="countryInput.slug"
            type="text"
          />
        </b-form-group>
         <b-form-group class="mt-1" v-slot="{ ariaDescribedby }">
          <label for="country_status" class="text-capitalize">
            وضعیت :
          </label>
          <b-form-radio
            v-model="countryInput.status"
            :aria-describedby="ariaDescribedby"
            value="active"
            >فعال</b-form-radio
          >
          <b-form-radio
            v-model="countryInput.status"
            :aria-describedby="ariaDescribedby"
            value="inactive"
            >پیش نویس</b-form-radio
          >
        </b-form-group>

      </b-container>
      <template #footer>
        <div class="d-flex align-items-center justify-content-end px-2 py-1">
          <b-button
            class="text-capitalize mr-2"
            @click="formModal = false"
            variant="outline-dark"
          >
            {{ $t("cancel") }}
          </b-button>
          <b-button variant="primary" @click="submitForm()">
            <div v-if="submitLoading" class="px-1">
              <b-spinner small style="width: 1.3rem; height: 1.3rem" />
              <span class="sr-only">Loading...</span>
            </div>
            <span v-else class="text-capitalize">
              {{ $t("submit") }}
            </span>
          </b-button>
        </div>
      </template>
    </b-sidebar>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BCard,
  BAvatar,
  BButton,
  BSpinner,
  BSidebar,
  BContainer,
  BFormTextarea,
   BFormRadio,
} from "bootstrap-vue";
import PerPage from "@/components/PerPage.vue";
import Breadcrumb from "@/components/Breadcrumb.vue";
import Pagination from "@/components/Pagination.vue";
import Search from "@/components/Search.vue";
import TableHead from "@/components/TableHead.vue";
import vSelect from "vue-select";

export default {
  components: {
    BRow,
    BCol,
    PerPage,
    BFormGroup,
    BFormInput,
    BCard,
    BAvatar,
    BButton,
    Breadcrumb,
    Pagination,
    Search,
    TableHead,
    BSpinner,
    BSidebar,
    BContainer,
    BFormTextarea,
    vSelect,
    BFormRadio
  },
  data() {
    return {
      perPage: 10,
      page: 1,
      countries: null,
      defaultAvatar: require("@/assets/images/avatars/default.png"),
      cancelToken: undefined,
      sortBy: "",
      sortDir: "",
      searchInput: "",
      paginationData: null,
      tableHeadings: [
        {
          title: "نام",
          slug: "name",
          sortable: true,
        },
        {
          title: "تاریخ ایجاد",
          slug: "created_at",
          sortable: true,
        },
        {
          title: "actions",
          sortable: false,
        },
      ],

      OpenIndicator: {
        render: (createElement) =>
          createElement("feather-icon", { attrs: { icon: "ChevronDownIcon" } }),
      },

      countryInput: {
        name: "",
        slug:"",
        status:"active"
       
      },
      editMode: false,
      formModal: false,
      submitLoading: false,
    };
  },
  mounted() {
    this.$store.commit("verticalMenu/UPDATE_VERTICAL_MENU_COLLAPSED", false);
    this.getCounties();
    // this.getCompanies();
  },
  watch: {
    searchInput(value) {
      this.page = 1;
      this.getCounties();
    },
    perPage(value) {
      this.page = 1;
      this.getCounties();
    },
    page(value) {
      this.getCounties();
    },
  },
  methods: {
    sort(args) {
      this.page = 1;
      this.sortBy = args.sortBy;
      this.sortDir = args.sortDir;
      this.getCounties();
    },

    async getCounties() {
      if (typeof this.cancelToken != typeof undefined) {
        this.cancelToken.cancel("Operation canceled due to new request.");
      }
      //Save the cancel token for the current request
      this.cancelToken = this.$http.CancelToken.source();

      let data = {
        paginate:true,
        //  this.searchInput,
        // per_page: this.perPage,
        page: this.page,
        // sort_by: this.sortBy,
        // sort_dir: this.sortDir,
      };

      const requestData = {
        method: "get",
        url: "/admin/countries",
        params: data,
        // cancelToken: this.cancelToken.token,
      };
      this.$http(requestData)
        .then((response) => {
          let data = response.data;
          this.countries = data.data;
          this.paginationData = data.meta;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    showConfirmModal(country) {
      this.$bvModal
        .msgBoxConfirm(
          "آیا از حذف کشور مطمئن هستید ؟" +
            `: ${country.name}.`,
          {
            title: this.$t("Please Confirm"),
            size: "sm",
            okVariant: "primary",
            okTitle: this.$t("Yes"),
            cancelTitle: this.$t("No"),
            cancelVariant: "outline-secondary",
            hideHeaderClose: false,
            centered: true,
          }
        )
        .then(async (confirmed) => {
          if (confirmed) {
            let countryIndex = 0;
            this.countries = await this.countries.filter((countryItem, index) => {
              if (countryItem.id == country.id) {
                countryIndex = index;
              }
              return countryItem.id !== country.id;
            });

            const requestData = {
              method: "delete",
              url: `/admin/countries/${country.id}`,
            };
            this.$http(requestData)
              .then((response) => {
                this.$bvToast.toast(
                  `کشور: ${country.name} با موفقیت حذف شد.`,
                  {
                    title: this.$t("Done"),
                    variant: "success",
                    solid: true,
                  }
                );
              })
              .catch((err) => {
                let message = this.$t("Unable to delete!");
                if (
                  err.response &&
                  err.response.data &&
                  err.response.data.message
                )
                  message = err.response.data.message;
                this.$bvToast.toast(message, {
                  title: this.$t("Error"),
                  variant: "danger",
                  solid: true,
                });
                this.countries.splice(countryIndex, 0, country);
              });
          }
        });
    },
    showFormModal(country) {
      if (country) {
        this.countryInput = {
          id: country.id,
          name: country.name,
          slug:country.slug,
          status:country.status,
        
        };
        this.editMode = true;
      } else {
        this.countryInput = {
          name: "",
          slug:"",
          status:"active",
        
        };
        this.editMode = false;
      }
      this.formModal = true;
    },
    submitForm() {
      if (this.submitLoading) return;
      let errorMessage = null;
     
      if (!errorMessage && !this.countryInput.name) {
        errorMessage = "لطفا نام کشور را وارد کنید";
      }
      if (!errorMessage && this.countryInput.name.length < 2) {
        errorMessage = "نام کشور نمی تواند کمتر از دو کاراکتر باشد";
      }
      if (!errorMessage && !this.countryInput.slug) {
        errorMessage = "لطفا اسلاگ کشور را وارد کنید";
      }
       if (!errorMessage && this.countryInput.slug.length < 2) {
        errorMessage = "اسلاگ کشور نمی تواند کمتر از دو کاراکتر باشد";
      }
     

      if (errorMessage) {
        this.$bvToast.toast(errorMessage, {
          title: this.$t("Error"),
          variant: "danger",
          solid: true,
        });
        return;
      }

      this.submitLoading = true;

      const requestData = {
        method: this.editMode ? "put" : "post",
        url: this.editMode ? `/admin/countries/${this.countryInput.id}` : `/admin/countries`,
        data: this.countryInput,
      };

      this.$http(requestData)
        .then((response) => {
          let message = "کشور با موفقیت اضافه شد";
          if (this.editMode) message = "کشور با موفقیت ویرایش شد";
          this.$bvToast.toast(message, {
            title: this.$t("Done"),
            variant: "success",
            solid: true,
          });
          if (!this.editMode && this.countries && this.countries.length > 0) {
            this.$refs.countriesPaginationComponent.clear();
            // this.$refs.countriesSearchComponent.clear();
            this.$refs.countriesTableHeadComponent.clear();
            this.page = 1;
            this.searchInput = "";
            this.sortBy = "";
            this.sortDir = "";
          }

          this.submitLoading = false;
          this.formModal = false;
          this.getCounties();
        })
        .catch((err) => {
          let message = "خطا در ایجاد کشور";
          if (this.editMode) message = "خطا در ویرایش کشور";
          if (err.response && err.response.data && err.response.data.message)
            message = err.response.data.message;

          this.$bvToast.toast(message, {
            title: this.$t("Error"),
            variant: "danger",
          });
          this.submitLoading = false;
          console.log(err);
        });
    },
  
   
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
